import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializePurchaseOrderCreate } from './serialize';

/** POST `/srm/purchase-order`。不送 purchaseOrderNo。 */
export async function createPurchaseOrder(payload) {
  const { data: raw } = await request.post(
    '/srm/purchase-order',
    serializePurchaseOrderCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
